import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { AuditLog, AuditLogGetParams } from "../types";
import { GatewayBase } from "../bases";

@Injectable({ providedIn: "root" })
export class AuditLogGateway extends GatewayBase {
    constructor(private _httpClient: HttpClient) {
        super();
    }

    getAuditLogs(params: AuditLogGetParams): Observable<AuditLog[]> {
        let queryParams = new HttpParams();
        if (params.organizationIds && params.organizationIds.length) {
            params.organizationIds.forEach(x => {
                queryParams = queryParams.append("organizationIds", x.toString());
            });
        }
        if (params.initiators && params.initiators.length) {
            params.initiators.forEach(x => {
                queryParams = queryParams.append("initiators", x);
            });
        }
        if (params.fromDate) {
            queryParams = queryParams.set("fromDate", params.fromDate.toISOString());
        }
        if (params.toDate) {
            queryParams = queryParams.set("toDate", params.toDate.toISOString());
        }

        return this._httpClient.get<AuditLog[]>(`/api/v1.0/audit-logs`, { params: queryParams });
    }
}
